import React from "react";
import {useRouter} from "next/router";
import {useSelector} from "react-redux";
import {IState} from "../../../../types/state";
import {FormattedMessage} from "react-intl";


const NewSearch = (props: { newSearchTitle: string }) => {

    const {newSearchTitle} = props
    const router = useRouter()

    const pageUrl = useSelector((state: IState) => state.smartSearch.smartSearchPageUrl)

    return <div className="new-search-feature">
        <div onClick={() => {
            router.push(pageUrl)
            setTimeout(() => {
                router.reload()
            }, 1000)
        }

        }>
            <span>
             <FormattedMessage id={newSearchTitle} defaultMessage={"new search"}/>
            </span>
        </div>

    </div>


}

export default NewSearch
